import MultiSelectBox from "./MultiSelectBox";
import { MultiSelectOption } from "./multiSelect-types";

/** 값 입력형의 최상단 액션 라벨. 둘을 나란히 노출합니다. */
const ALL_LABEL = "전체";
const CLEAR_LABEL = "전체 해제";

type Props = {
  options: MultiSelectOption[];
  /** 설정 값. 빈 배열은 '아무것도 선택하지 않음' 을 뜻합니다. */
  value: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  isDisabled?: boolean;
  className?: string;
};

/**
 * 설정 값 입력용 멀티셀렉트 (값 입력형).
 * 최상단 '전체' / '전체 해제' 는 일괄 선택 기능이며, 눌러도 레이어를 닫지 않습니다.
 * 선택 상태에 따라 각각 비활성됩니다. (0개면 '전체 해제', 모두 선택이면 '전체')
 *
 * 전부 선택해도 '모두' 같은 단일 값이 아니라 체크된 항목 목록을 그대로 내보냅니다.
 * 그래서 이후 항목이 추가되어도 기존 설정에 자동으로 포함되지 않습니다.
 */
const MultiSelectValue = ({ options, value, onChange, placeholder, isDisabled, className }: Props) => {
  const isAllSelected = options.length > 0 && value.length === options.length;
  const displayText = options
    .filter((option) => value.includes(option.value))
    .map((option) => option.label)
    .join(", ");

  const onToggleOption = (target: string) => {
    const nextValues = value.includes(target) ? value.filter((selected) => selected !== target) : [...value, target];
    onChange(nextValues);
  };

  return (
    <MultiSelectBox
      options={options}
      selectedValues={value}
      onToggleOption={onToggleOption}
      headerActions={[
        {
          label: ALL_LABEL,
          onClick: () => onChange(options.map((option) => option.value)),
          isDisabled: isAllSelected,
        },
        {
          label: CLEAR_LABEL,
          onClick: () => onChange([]),
          isDisabled: value.length === 0,
        },
      ]}
      displayText={displayText}
      placeholder={placeholder}
      isDisabled={isDisabled}
      className={className}
    />
  );
};

export default MultiSelectValue;
